import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthState, UserInfo } from '@/models';

type AuthPayload = {
  accessToken: string;
  refreshToken: string;
  userInfo: UserInfo | null;
};

const initialState: AuthState = {
  isAuthenticated: false,
  accessToken: null,
  refreshToken: null,
  userInfo: null,
};

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<AuthPayload>) => {
      state.isAuthenticated = true;
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.userInfo = action.payload.userInfo;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.accessToken = null;
      state.refreshToken = null;
      state.userInfo = null;
    },
    setNewTokens: (state, action: PayloadAction<AuthPayload>) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      if (action.payload.userInfo) {
        state.userInfo = action.payload.userInfo;
      }
    },
  },
});

export const { login, logout, setNewTokens } = slice.actions;
export const authReducer =  slice.reducer;
